import get from 'lodash/get'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'
import { buildFilters } from './utils'

export default {
  namespaced: true,

  state: {
    list: [],
    allPageviews: [],
    item: {
      kit: null,
      pageviewCounts: {}
    },
    topPageviews: [],
    pagination: {}
  },

  getters: {
    currentKits: (state) => state.list,
    currentKit: (state) => state.item.kit,
    currentTopPageviews: (state) => state.topPageviews,
    currentPagination: (state) => state.pagination,
    allPageviews: (state) => state.allPageviews
  },

  mutations: {
    allPageviewsFetched(state, { allPageviews }) {
      state.allPageviews = allPageviews
    },

    kitsFetched(state, { kits }) {
      state.list = kits
    },

    kitFetched(state, { kit }) {
      state.item.kit = kit
    },

    topPageviewsFetched(state, { topPageviews }) {
      state.topPageviews = topPageviews
    },

    paginationFetched(state, { pagination }) {
      state.pagination = pagination
    }
  },

  actions: {
    async fetchKits({ commit }, { page = 1, filters = {} }) {
      const response = await fetch({
        url: '/api/admin/kits',
        params: {
          page,
          ...buildFilters(filters)
        }
      })

      const kits = await deserialize(response.data)
      const pagination = formatMeta(get(response.data, 'meta', {}))

      commit('kitsFetched', { kits })
      commit('paginationFetched', { pagination })
    },

    async fetchAllPageviews({ commit }, payload) {
      const response = await fetch({
        url: `/api/admin/all/pageviews/${payload.id}`,
        params: {
          id: payload.id,
          year: payload.year
        }
      })
      const allPageviews = await deserialize(response.data)
      commit('allPageviewsFetched', { allPageviews })
    },

    async fetchTopPageviews({ commit }) {
      const response = await fetch({ url: '/api/admin/top/pageviews' })

      const topPageviews = await deserialize(response.data)

      commit('topPageviewsFetched', { topPageviews })
    },

    async fetchKit({ commit }, kitId) {
      const response = await fetch({ url: `/api/admin/kits/${kitId}` })

      const kit = await deserialize(response.data)

      commit('kitFetched', { kit })
    },

    async updateKit({ commit, state }, changes) {
      const response = await update({
        url: `/api/admin/kits/${state.item.kit.id}`,
        type: 'kit',
        changes,
        record: state.item
      })
      const kit = await deserialize(response.data)

      commit('kitFetched', { kit })
    }
  }
}
